import React from 'react';
import styled from 'styled-components';

const ChartLoader = (props) => {
  return (
    <Loader>
      <div className="preloader">
        <span />
        <span />
        <span />
        <span />
        <span />
      </div>
    </Loader>
  );
};

export default ChartLoader;

const Loader = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  .preloader {
    position: relative;
    width: 25px;
    height: 100%;
    transform: translate(-50%, -50%);
  }
`;
